import React from 'react';
import { motion } from 'framer-motion';
import { PhoneIcon, MessageSquareIcon, ClockIcon, MapPinIcon } from 'lucide-react';
import { PHONE_DISPLAY, PHONE_HREF, SMS_HREF } from '../lib/contact';
export function Contact() {
  return <section id="contact" className="bg-wine py-16 sm:py-24" data-id="element-10" data-mp="3173gd45c58em">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-11" data-mp="2w80f7ush7mbx">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.6
      }} data-id="element-12" data-mp="2w9th6ws59idl">
          <span className="font-stamp text-xs uppercase tracking-[0.25em] text-cream/70" data-id="element-13" data-mp="3k561h7uril75">
            Let&rsquo;s Talk
          </span>
          <h2 className="mt-3 font-display text-3xl text-cream sm:text-4xl" data-id="element-14" data-mp="3f59t6wf187ls">
            Give us a call or send a text.
          </h2>
          <p className="mx-auto mt-4 max-w-xl font-body text-lg text-cream/85" data-id="element-15" data-mp="gifi1b4f31b1">
            Tell us whether you want to buy, rent, or outfit a venue — and any custom
            details you have in mind. We&rsquo;ll get right back to you.
          </p>

          <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row" data-id="element-16" data-mp="3ouxp9aauwdr5">
            <a href={PHONE_HREF} className="inline-flex items-center justify-center gap-2 rounded-sm bg-cream px-6 py-4 font-stamp text-sm uppercase tracking-widest text-wine transition-colors hover:bg-parchment" data-id="element-17" data-mp="3b3sualifo9n5">
              <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-18" data-mp="313s9sw8tvnhd" />
              Call {PHONE_DISPLAY}
            </a>
            <a href={SMS_HREF} className="inline-flex items-center justify-center gap-2 rounded-sm border-2 border-cream px-6 py-4 font-stamp text-sm uppercase tracking-widest text-cream transition-colors hover:bg-cream hover:text-wine" data-id="element-19" data-mp="361tqxbmp1cq7">
              <MessageSquareIcon className="h-5 w-5" aria-hidden="true" data-id="element-20" data-mp="qdtmcc1e20kj" />
              Text {PHONE_DISPLAY}
            </a>
          </div>

          <div className="mt-10 flex flex-col items-center justify-center gap-4 border-t border-cream/25 pt-8 font-body text-sm text-cream/80 sm:flex-row sm:gap-10" data-id="element-21" data-mp="23bc5j9lies25">
            <span className="inline-flex items-center gap-2" data-id="element-22" data-mp="1yelpundm9yh9">
              <MapPinIcon className="h-4 w-4" aria-hidden="true" data-id="element-23" data-mp="1ubxg8dh2wnj8" />
              Santa Barbara, CA
            </span>
            <span className="inline-flex items-center gap-2" data-id="element-24" data-mp="1pddr6476uvmn">
              <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-25" data-mp="2m2blxmexutjt" />
              Calls &amp; texts, 9am&ndash;6pm PT
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}